<button 
    mat-mini-fab 
    class="admin-theme" 
    (click)="openConfigDialog()">
    <mat-icon>settings</mat-icon>
</button>